<template>

<div>
  <nav class="navbar navbar-expand navbar-dark bg-dark">
    <div class="container">
      <a class="navbar-brand" id="nav-principal" href="javascript:void(0);">AMPA</a>
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" id="nav-principal">
          <a href="https://www.apa-pablo-picasso.es">Web del AMPA</a>
        </li>
      </ul>
    </div>
  </nav>

  <div class="container py-3" id="contenido">
    <router-view />
  </div>
</div>

</template>

<script>

export default {
	name: 'AreaExterna',
}
</script>
